import "./styles.css";

const app = document.querySelector<HTMLElement>("#app");

if (!app) {
  throw new Error("Missing #app root.");
}

app.innerHTML = `
  <section class="hero" aria-labelledby="page-title">
    <div class="hero__content">
      <p class="eyebrow">Daily playable fates</p>
      <h1 id="page-title">Today I Was</h1>
      <p class="lede">
        A tiny game for the thing you became today. The first season is taking shape now.
      </p>
      <a class="primary-link" href="https://todayiwas.com/" aria-label="Reload Today I Was">
        Stay close
      </a>
    </div>
  </section>
`;
